<script setup lang="ts">
defineProps<{
  title: string;
  hideBackButton?: boolean;
}>();

const emit = defineEmits<{
  (e: "close-menu"): void;
  (e: "back-click"): void;
}>();

type Slots = {
  default(): any;
  actions?(): any;
};

defineSlots<Slots>();

const goBack = () => emit("back-click");

const closeMenu = () => emit("close-menu");
</script>

<template>
  <div
    class="menu-with-header__top"
    v-bind="$attrs"
  >
    <div class="flex items-center">
      <button
        v-if="!hideBackButton"
        class="menu-with-header__back-button"
        data-cy="menu-with-header-back-button"
        @click="goBack"
      >
        <BaseIcon
          name="arrowLeft"
          :size="20"
        />
      </button>
      <span class="text-xl font-bold block uppercase">
        {{ title }}
      </span>
    </div>

    <button
      class="flex items-center justify-center"
      data-test="close-menu-button"
      @click="closeMenu"
    >
      <BaseIcon
        name="close"
        :size="24"
      />
    </button>
  </div>
  <div
    class="menu-with-header__container"
    :class="{
      'menu-with-header__container--actions': Boolean($slots.actions),
    }"
  >
    <slot />
  </div>
  <div
    v-if="$slots.actions"
    class="menu-with-header__actions"
  >
    <slot name="actions" />
  </div>
</template>

<style lang="postcss" scoped>
.menu-with-header {
  &__top {
    @apply w-full p-4 sticky top-0 md:pt-8;
    @apply flex justify-between bg-platform-bg-1 z-50 border-b border-solid;
  }

  &__back-button {
    @apply flex gap-1 items-center pr-4 text-sm font-normal;
    &__icon {
      @apply -scale-x-90;
    }
    &__text {
      @apply h-full flex items-center;
    }
  }

  &__container {
    &--actions {
      @apply min-h-[calc(100vh-144px)] md:min-h-[calc(100vh-160px)];
    }
  }

  &__actions {
    @apply w-full sticky bottom-0 mt-4;
  }
}
</style>
